import { render, staticRenderFns } from "./BatchAddTopic.vue?vue&type=template&id=0f66cf89&scoped=true"
import script from "./BatchAddTopic.vue?vue&type=script&lang=js"
export * from "./BatchAddTopic.vue?vue&type=script&lang=js"
import style0 from "./BatchAddTopic.vue?vue&type=style&index=0&id=0f66cf89&prod&lang=scss&scoped=true"
import style1 from "./BatchAddTopic.vue?vue&type=style&index=1&id=0f66cf89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66cf89",
  null
  
)

export default component.exports